import Constants from 'expo-constants';
import { Platform } from 'react-native';
import type { AppUpdateConfig } from './bootstrapMobileSessionService';

/** Compara dos versiones semver (major.minor.patch). Devuelve -1, 0, 1. */
export function compareSemver(a: string, b: string): number {
  const pa = a.split('.').map(Number);
  const pb = b.split('.').map(Number);
  for (let i = 0; i < 3; i++) {
    const va = pa[i] ?? 0;
    const vb = pb[i] ?? 0;
    if (va < vb) return -1;
    if (va > vb) return 1;
  }
  return 0;
}

export function getAppVersion(): string {
  return Constants.expoConfig?.version ?? '0.0.0';
}

export function needsForceUpdate(config: AppUpdateConfig | null): boolean {
  if (!config || !config.required) return false;
  // Web siempre es la última versión (Vercel auto-deploy). No aplica force-update.
  if (Platform.OS === 'web') return false;
  const current = getAppVersion();
  const min = Platform.OS === 'ios' ? config.min_version_ios : config.min_version_android;
  return compareSemver(current, min) < 0;
}

export function getStoreUrl(config: AppUpdateConfig): string | null {
  const url = Platform.OS === 'ios' ? config.store_url_ios : config.store_url_android;
  // No abrir links placeholder (idXXXX) o vacíos
  if (!url || url.includes('XXXX')) return null;
  return url;
}
